import React from "react";
import { ContentSection } from "sprint-common-web";

import { LanguagesDataProvider } from "../../../../../../../common/data/lookup-data-providers/LanguagesDataProvider";
import {
    ensureAudioFileRecordDetails,
    FileRecordDetails
} from "../../../../../../common/file-record-details/FileRecordDetails";
import { AudioFileRecordLanguagesView } from "../../../../../../common/file-record-details/languages/AudioFileRecordLanguagesView";

interface AudioFileRecordLanguagesSectionProps {
    fileRecordDetails: FileRecordDetails;
    isFileRecordDetailsLoading: boolean;
    height: number;
}

export const AudioFileRecordLanguagesSection = ({
    height,
    fileRecordDetails,
    isFileRecordDetailsLoading
}: AudioFileRecordLanguagesSectionProps): JSX.Element => {
    ensureAudioFileRecordDetails(fileRecordDetails);

    return (
        <LanguagesDataProvider>
            <ContentSection
                header="File record languages"
                isLoading={isFileRecordDetailsLoading}
                testId="languages-content-section"
            >
                <AudioFileRecordLanguagesView fileRecordDetails={fileRecordDetails} height={height} />
            </ContentSection>
        </LanguagesDataProvider>
    );
};
